import { useEffect } from 'react';
import { QRCodeSVG } from 'qrcode.react';
import { useIntl } from 'react-intl';
import ApiErrorAlert from 'src/components/_common/ApiErrorAlert/ApiErrorAlert';
import Button from 'src/components/_common/Button/Button';
import Spinner from 'src/components/_common/Spinner/Spinner';
import { useCreateQrSupervisorInvitation } from './queries';

interface QrInvitationProps {
  onBack: () => void;
}

export default function QrInvitation({ onBack }: QrInvitationProps) {
  const { formatMessage } = useIntl();
  const createQrInvitationMutation = useCreateQrSupervisorInvitation();

  useEffect(() => {
    createQrInvitationMutation.mutate();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="flex flex-col items-center">
      {createQrInvitationMutation.isLoading && <Spinner />}
      {createQrInvitationMutation.isError && (
        <ApiErrorAlert
          error={createQrInvitationMutation.error}
          message={formatMessage({ id: 'inviteSupervisorQrErrorMessage' })}
        />
      )}
      {createQrInvitationMutation.isSuccess && (
        <div className="flex flex-col items-center" data-testid="qr-invitation-code">
          <p className="mb-4">{formatMessage({ id: 'inviteSupervisorQrHelpText' })}</p>
          <QRCodeSVG value={createQrInvitationMutation.data} size={200} />
        </div>
      )}
      <Button layout="outline" className="mt-6" onClick={onBack}>
        {formatMessage({ id: 'inviteSupervisorQrToggleToEmail' })}
      </Button>
    </div>
  );
}
